import axiosInstance from "../axiosInstance";
import { GetAgentNotesResponseObj, GetNotesArgs, CreateNotePayload, UpdateNotePayload } from "@/types/interfaces/notes";

export const getAgentNotes = async (args: GetNotesArgs): Promise<GetAgentNotesResponseObj> => {
  const res = await axiosInstance.get("/notes", {
    params: {
      find: JSON.stringify(args),
    },
  });

  const { message, count } = res.data;

  return {
    notes: message || [],
    count: count || 0,
  };
};

export const createNote = async (data: CreateNotePayload) => {
  const res = await axiosInstance.post(`/notes`, data);
  return res.data;
};

export const updateNotes = async (noteId: string, data: UpdateNotePayload) => {
  const res = await axiosInstance.put(`/notes/${noteId}`, data);
  return res.data;
};
